<template>
  <vs-popup
    class="holamundo"
    :title="title"
    :active.sync="addNewDataLocal"
    @vs-close="closeForm">
    <p>
      Add notes related to the alert by providing a detailed explanation in text
      and attaching a picture to provide context and clarity.
    </p>
    <form class="mt-5">
      <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label for="" class="text-bold">Problem Category</label>
        <vs-select class="w-full" label="" v-model="problem_category" disabled>
          <vs-select-item :key="index" :value="item.value" :text="item.text"
            v-for="(item, index) in listProblemCategories" />
        </vs-select>
      </div>

      <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label for="">Problem Identification</label>
        <vs-select class="w-full" label="" v-model="problem_identification" disabled>
          <vs-select-item :key="index" :value="item.value" :text="item.text"
            v-for="(item, index) in listProblemIdentifications" />
        </vs-select>
      </div>
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Notes<sup>*</sup></label>
        <div>
          <vs-textarea
            v-model="notes"
            rows="5"
            style="border: 1px solid rgba(0, 0, 0, 0.2)"
            :disabled="!this.is_editable" />
        </div>
        <span></span>
      </div>
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <br />
        <div v-if="dataEdit.attachment">
          <template
            v-if="
              Array.isArray(dataEdit.attachment) && dataEdit.attachment.length
            ">
            <img
              v-for="(attachment, index) in dataEdit.attachment"
              :key="index"
              class="cursor-pointer mr-2"
              height="150px"
              :src="attachment"
              @click="onClickImage(attachment)"
              alt="Uploaded Image" />
          </template>
          <template v-else>
            <img
              v-if="dataEdit.attachment"
              class="cursor-pointer mr-2"
              height="150px"
              :src="dataEdit.attachment"
              @click="onClickImage(dataEdit.attachment)"
              alt="Uploaded Image" />
          </template>
        </div>
        <div
          :class="!this.is_editable ? 'hidden' : 'flex flex-row items-center'"
          style="gap: 10px">
          <div class="fileUpload rounded-lg flex items-center">
            <input
              type="file"
              class="upload"
              @change="handlePictureChange"
              :key="fileUploadKey" />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M4.5551 16.5556C2.60745 16.5556 1.02856 15.2273 1.02856 13.2796C1.02856 11.332 2.60745 9.75307 4.5551 9.75307C4.68754 9.75307 4.81828 9.76038 4.94693 9.7746V9.75307H4.99544C4.96342 9.49635 4.94693 9.2348 4.94693 8.9694C4.94693 5.50691 7.75383 2.70001 11.2163 2.70001C13.561 2.70001 15.6051 3.98715 16.6805 5.89339C16.9433 5.85473 17.2122 5.83471 17.4857 5.83471C20.5154 5.83471 22.9714 8.29074 22.9714 11.3204C22.9714 13.8144 21.3071 15.7156 19.0286 16.3423M11.8269 21.3V12.3M11.8269 12.3L8.22856 16.0117M11.8269 12.3L15.4286 16.0117"
                stroke="#828282"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span class="ml-2">Upload Picture</span>
          </div>
          <p>{{ this.filename }}</p>
        </div>
        <p class="text-xs mt-3 ml-2">
          *Hanya menerima file image (.jpg, .jpeg, .png)
        </p>
        <span></span>
      </div>
      <!-- <vs-button color="danger" type="filled" class="mb-0" @click="testingBtn"
        >test</vs-button
      > -->
    </form>
    <vs-divider />
    <div class="vx-row">
      <div class="vx-col">
        <vs-button color="warning" type="border" class="mb-0" @click="closeForm"
          >Cancel</vs-button
        >
      </div>
      <!-- <div class="vx-col"> -->
      <vs-button
        v-if="this.is_editable"
        color="danger"
        type="filled"
        class="mb-0 btn-submit"
        @click="submitsForm"
        :disabled="this.notes == '' || this.filename == ''"
        >Submit</vs-button
      >
      <!-- </div> -->
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'
import * as moment from 'moment'
import imageCompression from 'browser-image-compression'
import {
  getProblemCategoriesFromJson,
  getVerificationProblemCategories,
  getProblemIdentificationsFromJson,
} from '../../../helper/problemOptions'

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    id: String,
    imei: String,
    title: String,
    editMode: Boolean,
    dataEdit: Object,
  },
  mounted() {
    //
    //
  },
  watch: {
    async editMode(val) {
      this.clearFields()
      if (
        this.dataEdit.verified_by != null &&
        this.dataEdit.verified_by != ''
      ) {
        this.notes = this.dataEdit.note
        this.problem_category = this.dataEdit.problem_category
        this.problem_identification = this.dataEdit.problem_identification
        if (Array.isArray(this.dataEdit.attachment)) {
          this.dataEdit.attachment.map(async (attachment) => {
            try {
              const res = await fetch(attachment)
              const blob = await res.blob()
              const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
              this.images.push(file)
            } catch (error) {
              console.error('Error fetching or processing attachment:', error)
            }
          })
        } else if (this.dataEdit.attachment) {
          try {
            const res = await fetch(this.dataEdit.attachment)
            const blob = await res.blob()
            const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
            this.images.push(file)
          } catch (error) {
            console.error('Error fetching or processing attachment:', error)
          }
        }
        this.is_editable = false
      }
    },
    problem_category(val) {
      const problemIdentifications = getProblemIdentificationsFromJson(val)
      if (problemIdentifications) {
        this.listProblemIdentifications = problemIdentifications
        return
      }

      switch (val) {
        case 'Pengemudi':
          this.listProblemIdentifications = [
            { value: 'Melanggar Kebijakan', text: 'Melanggar Kebijakan' },
          ]
          break
        case 'Fleet':
          this.listProblemIdentifications = [
            { value: 'Unit Belum Dimutasi', text: 'Unit Belum Dimutasi' },
            { value: 'Speedometer Error', text: 'Speedometer Error' },
            {
              value: 'Unit Dibawa Mekanik/Driver Ekspedisi',
              text: 'Unit Dibawa Mekanik/Driver Ekspedisi',
            },
          ]
          break
        case 'Operasional':
          this.listProblemIdentifications = [
            {
              value: 'Pengemudi Melanggar Kecepatan Karena Permintaan Customer',
              text: 'Pengemudi Melanggar Kecepatan Karena Permintaan Customer',
            },
          ]
          break
        case 'Fico Verifikasi':
          this.listProblemIdentifications = [
            {
              value: 'Pengemudi Belum Di Briefing Terkait Kebijakan Overspeed',
              text: 'Pengemudi Belum Di Briefing Terkait Kebijakan Overspeed',
            },
            {
              value:
                'Pengemudi Freelance Belum Di Briefing Terkait Kebijakan Overspeed',
              text: 'Pengemudi Freelance Belum Di Briefing Terkait Kebijakan Overspeed',
            },
          ]
          break
        case 'Fico Tidak Verifikasi':
          this.listProblemIdentifications = [
            { value: 'Fico Tidak Verifikasi', text: 'Fico Tidak Verifikasi' },
          ]
          break
        case 'Sistem':
          this.listProblemIdentifications = [
            { value: 'Sistem Error', text: 'Sistem Error' },
            { value: 'Akun Belum Di Buat', text: 'Akun Belum Di Buat' },
          ]
          break
        default:
          this.listProblemIdentifications = []
          break
      }
    },
  },
  computed: {
    addNewDataLocal: {
      get() {
        //
        return JSON.parse(this.isOpen)
      },
      set(val) {
        //
        this.closeForm()
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
    listProblemCategories() {
      const verificationCategories = getVerificationProblemCategories()
      const isLegacyCategory =
        this.problem_category &&
        !verificationCategories.some(
          (item) => item.value === this.problem_category
        )
      return isLegacyCategory
        ? getProblemCategoriesFromJson()
        : verificationCategories
    },
  },
  data() {
    return {
      parent_array: [],
      is_editable: true,
      notes: '',
      image: [],
      filename: '',
      fileUploadKey: 0,
      legacyProblemCategories: [
        { value: 'Pengemudi', text: 'Pengemudi' },
        { value: 'Fleet', text: 'Fleet' },
        { value: 'Operasional', text: 'Operasional' },
        { value: 'Fico Verifikasi', text: 'Fico Verifikasi' },
        { value: 'Fico Tidak Verifikasi', text: 'Fico Tidak Verifikasi' },
        { value: 'Sistem', text: 'Sistem' },
      ],
      listProblemIdentifications: [],
      problem_category: '',
      problem_identification: '',
    }
  },
  methods: {
    onClickImage(attachment) {
      window.open(attachment, '_blank')
    },
    closeForm() {
      //
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.notes = ''
      this.image = null
      this.filename = ''
      this.fileUploadKey++
      this.is_editable = true
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    handlePictureChange(e) {
      this.filename = e.target.files[0].name
      this.image = e.target.files[0]

      this.dataEdit.attachment = URL.createObjectURL(this.image)
    },
    successUpload() {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Lorem ipsum dolor sit amet, consectetur',
      })
    },
    submitsForm() {
      this.loadingBtnStart('btn-submit')
      let dataForm = {
        imei: this.imei,
        note: this.notes,
        verified_date: moment().format('YYYY-MM-DD HH:mm'),
        verified_by: JSON.parse(localStorage.getItem('userInfo')).name,
      }

      if (this.image) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        }
        imageCompression(this.image, options)
          .then((compressedFile) => {
            //
            let formData = new FormData()
            formData.append('file', compressedFile)
            formData.append('dir', 'alert' + '/' + this.dataEdit.license_plate)

            //
            REPO.updateFileHistory(formData, this.id).then((res) => {
              //
              dataForm.attachment = res.data.data.url
              //
              //
              REPO.updateAlertHistory(dataForm, this.id).then((res) => {
                //
                this.loadingBtnStop('btn-submit')
                this.$emit('submitModal', false)
                this.successUpload()
                this.closeForm()
                this.$root.$emit('reloadNotifAtas')
              })
            })
          })
          .catch((error) => {})
      } else {
        REPO.updateAlertHistory(dataForm, this.id).then((res) => {
          //
          this.loadingBtnStop('btn-submit')
          this.$emit('submitModal', false)
          this.successUpload()
          this.closeForm()
          this.$root.$emit('reloadNotifAtas')
        })
      }
    },
  },
}
</script>
<style>
sup {
  color: red;
}

.fileUpload {
  background: transparent;
  color: #333333;
  font-size: 1em;
  overflow: hidden;
  padding: 0.875em; /*14px/16px*/
  position: relative;
  text-align: center;
  width: fit-content;
  cursor: pointer;
  border: 1px solid var(--Gray-4, #bdbdbd);
}
.fileUpload:hover,
.fileUpload:active,
.fileUpload:focus {
  background: transparent;
  cursor: pointer;
}
.fileUpload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  width: 148px;
  height: 46px;
  cursor: pointer;
}

input[type='file'] {
  position: fixed;
  right: 100%;
  bottom: 100%;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
</style>
